module.exports = __webpack_public_path__ + "static/inevia-references-rail-tramway-85d7e840537357f94bc06e0911ef5f73.pdf";